import { useTranslation } from 'react-i18next';
import { FormControl, FormHelperText } from '@mui/material';

import { CustomFormLabel, RHFFileField } from '@/components/form-controls';

export const ImageFileField = () => {
  const { t } = useTranslation('nomenclature-page');

  return (
    <FormControl fullWidth>
      <CustomFormLabel htmlFor="file">{t('modals.form.ui.images.file-selection')}</CustomFormLabel>
      <RHFFileField
        fullWidth
        name="file"
        id="file"
        variant="filled"
        placeholder=" "
        inputProps={{
          accept: 'image/jpeg, image/png, image/webp',
        }}
      />
      <FormHelperText>{t('modals.form.ui.images.allowed-formats')}</FormHelperText>
    </FormControl>
  );
};
